export default __webpack_public_path__ + "static/media/iconMinus.4c95bd58.svg";